import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Lock, CheckCircle2, AlertCircle } from 'lucide-react';
export function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  // Simple password strength calculation
  const strength = Math.min(100, password.length / 12 * 100);
  const strengthColor = strength < 33 ? 'bg-red-500' : strength < 66 ? 'bg-amber-500' : 'bg-green-500';
  return <div className="min-h-screen bg-background flex items-center justify-center p-6" data-id="element-5715">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md" data-id="element-5716">
        <div className="flex flex-col items-center mb-8" data-id="element-5717">
          <Link to="/" className="flex items-center gap-2 mb-6" data-id="element-5718">
            <span className="text-2xl font-bold tracking-tight text-textMain" data-id="element-5719">
              Booker
            </span>
            <div className="w-2 h-2 rounded-full bg-primary mt-1" data-id="element-5720"></div>
          </Link>
          <h1 className="text-2xl font-bold text-textMain mb-2" data-id="element-5721">
            Set a new password
          </h1>
          <p className="text-textMuted text-sm text-center" data-id="element-5722">
            Please enter your new password below.
          </p>
        </div>

        <div className="bg-surface border border-border rounded-xl p-6 shadow-xl" data-id="element-5723">
          {status === 'success' ? <div className="text-center py-4" data-id="element-5724">
              <div className="w-12 h-12 rounded-full bg-green-500/10 flex items-center justify-center mx-auto mb-4" data-id="element-5725">
                <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-5726" />
              </div>
              <h3 className="text-lg font-semibold mb-2" data-id="element-5727">
                Password reset successful
              </h3>
              <p className="text-sm text-textMuted mb-6" data-id="element-5728">
                Your password has been successfully updated.
              </p>
              <Link to="/login" className="w-full block py-2.5 bg-primary text-background rounded-lg text-sm font-medium hover:bg-primaryHover transition-colors text-center" data-id="element-5729">
                Log in
              </Link>
            </div> : status === 'error' ? <div className="text-center py-4" data-id="element-5730">
              <div className="w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center mx-auto mb-4" data-id="element-5731">
                <AlertCircle className="w-6 h-6 text-red-500" data-id="element-5732" />
              </div>
              <h3 className="text-lg font-semibold mb-2" data-id="element-5733">Link expired</h3>
              <p className="text-sm text-textMuted mb-6" data-id="element-5734">
                This password reset link has expired or is invalid.
              </p>
              <Link to="/forgot-password" className="w-full block py-2.5 bg-background border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors text-center" data-id="element-5735">
                Request new link
              </Link>
            </div> : <form className="space-y-5" onSubmit={e => {
          e.preventDefault();
          setStatus('success');
        }} data-id="element-5736">
              <div data-id="element-5737">
                <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5738">
                  New Password
                </label>
                <div className="relative mb-2" data-id="element-5739">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textMuted" data-id="element-5740" />
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" placeholder="••••••••" required data-id="element-5741" />
                </div>
                {password.length > 0 && <div className="flex items-center gap-2" data-id="element-5742">
                    <div className="flex-1 h-1.5 bg-background rounded-full overflow-hidden" data-id="element-5743">
                      <div className={`h-full ${strengthColor} transition-all duration-300`} style={{
                  width: `${strength}%`
                }} data-id="element-5744"></div>
                    </div>
                    <span className="text-[10px] text-textMuted uppercase font-bold tracking-wider" data-id="element-5745">
                      {strength < 33 ? 'Weak' : strength < 66 ? 'Good' : 'Strong'}
                    </span>
                  </div>}
              </div>

              <div data-id="element-5746">
                <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5747">
                  Confirm Password
                </label>
                <div className="relative" data-id="element-5748">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textMuted" data-id="element-5749" />
                  <input type="password" className="w-full pl-10 pr-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" placeholder="••••••••" required data-id="element-5750" />
                </div>
              </div>

              <button className="w-full py-2.5 mt-2 bg-primary text-background rounded-lg font-medium hover:bg-primaryHover transition-colors shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-5751">
                Reset password
              </button>
            </form>}
        </div>
      </motion.div>
    </div>;
}